module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "acitve-items",
    on: {
      "click": function($event) {
        return _vm.toActivityDetail(_vm.content)
      }
    }
  }, [_c('div', {
    staticClass: "active-items-title-read"
  }, [_c('div', {
    staticClass: "active-item-title"
  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _c('div', {
    staticClass: "active-itme-read"
  }, [_vm._v("211阅读")])]), _vm._v(" "), (_vm.content.pics_url.length > 0) ? _c('div', {
    staticClass: "active-item-pics"
  }, [_c('img', {
    attrs: {
      "src": _vm.content.pics_url[0],
      "alt": ""
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d51bd4a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/Activity1.vue
// module id = 1601
// module chunks = 0